import { useEffect } from "react";
import { useAnimation, motion } from "framer-motion";
import { useInView } from "react-intersection-observer";

const bounceVariant = {
  visible: {transform: 'TranslateY(0px)', opacity: 1, transition: {duration: 0.8}},
  hidden: {transform: 'TranslateY(60px)', opacity: 0.6}
}

export const MotionFrame = ({ children }) => {
    const controls = useAnimation();
    const [ref, inView] = useInView();
    useEffect(() => {
        if (inView) {
            controls.start("visible");
        }
    }, [controls, inView]);
    return (
        <motion.div
            ref={ref}
            animate={controls}
            initial="hidden"
            variants={bounceVariant}
            className="square"
        >
            {children}
        </motion.div>
    ); 
}